<template>
  <div class="selected-filters clearfix d-flex flex-nowrap flex-lg-wrap overflow-auto">
    <span
      v-for="tag in tagList"
      :key="tag.id"
      :class="'selected-filter filter-' + tag.id"
      rel="nofollow"
      @click="removeTag(tag)"
      @keyup.enter="removeTag(tag)"
      @keydown.space.prevent="removeTag(tag)"
      :aria-label="facetInfo[tag.id].name + ':' + tag.name + ' ' + $translate('Ceres::Template.itemFilterReset')"
      role="button"
      tabindex="0"
    >
      <span
        v-if="facetInfo[tag.id]"
        class="text-nowrap"
      >
        {{ facetInfo[tag.id].name }}: {{ tag.name }}
        <i
          class="fa fa-times"
          aria-hidden="true"
        />
      </span>
      <span
        v-else
        class="text-nowrap"
      >
        {{ tag.name }}
        <i
          class="fa fa-times"
          aria-hidden="true"
        />
      </span>
    </span>
    <span
      v-if="tagList.length >= 2"
      class="selected-filter reset-all text-nowrap"
      rel="nofollow"
      role="button"
      :aria-label="$translate('Ceres::Template.itemFilterReset')"
      @click="resetAllTags()"
      @keyup.enter="resetAllTags()"
      @keydown.space.prevent="resetAllTags()"
      tabindex="0"
    >
      {{ $translate("Ceres::Template.itemFilterReset") }}
    </span>
  </div>
</template>

<script>
import url from '../../../../mixins/url'

export default {
    name: 'ItemFilterTagList',
    mixins: [url],
    props:
            {
                template:
                    {
                        type: String,
                        default: '#vue-item-filter-tag-list'
                    },
                marginClasses:
                    {
                        type: String,
                        default: null
                    },
                marginInlineStyles:
                    {
                        type: String,
                        default: null
                    }
            },
    computed: {
        tagList () {
            return this.getSelectedFilters()
        },
        facetInfo () {
            return this.getFacetIdInfoMap()
        }
    },

    methods: {
        removeTag (tag) {
            this.removeSelectedFilter(tag.id, tag.name)
        },

        resetAllTags () {
            this.removeAllAttribsAndRefresh()
        }
    }
}
</script>

<style scoped>

</style>
